/** @format */

import { useGetApplicationByJobID } from "../../../../api/queries/application.query";
import { useGetJobMeCompany } from "../../../../api/queries/job.query";

const { Fragment } = require("react");
const { Card, Image, Badge } = require("react-bootstrap");

const All = () => {
  const { data: jobData, isLoading: isLoadingJobData } = useGetJobMeCompany({
    select: (response) => response.data.jobs,
  });

  const { data: application, isLoading: isLoadingApplicationData } =
    useGetApplicationByJobID({
      select: (response) => response.data.user,
      enable: !!jobData?.id,
      params: {
        job_id: jobData?.id,
      },
    });
  console.log("job data", jobData);
  console.log("job data", jobData);
  const tableData = [
    {
      name: "Tiger Nixon",
      position: "System Architect",
      office: "Edinburgh",
      age: "61",
      startdate: "2011/04/25",
      salary: "$320,800",
    },
    {
      name: "Garrett Winters",
      position: "Accountant",
      office: "Tokyo",
      age: "63",
      startdate: "2011/07/25",
      salary: "$170,750",
    },
    {
      name: "Ashton Cox",
      position: "Junior Technical Author",
      office: "San Francisco",
      age: "66",
      startdate: "2009/01/12",
      salary: "$86,000",
    },
  ];

  return (
    <Fragment>
      <Card>
        <Card.Body className="">
          <div className="table-responsive rounded">
            <table className="table table-striped">
              <tbody>
                {isLoadingJobData ? (
                  <tr>
                    <td colSpan="5">
                      <p>Loading...</p>
                    </td>
                  </tr>
                ) : jobData && jobData.length > 0 ? (
                  jobData.map((job) => (
                    <tr key={job?.id} className="border-0">
                      <td className="border-0">
                        <Image
                          src={job?.image || "defaultImage.png"}
                          className="img-fluid avatar-40 rounded-circle"
                          alt="img"
                        />
                      </td>
                      <td className="border-0">
                        <h5 className="mb-1">
                          {job?.title || "N/A"}{" "}
                          <Badge bg="success" className="mt-2">
                            NEW
                          </Badge>
                        </h5>
                        <h6 className="text-secondary">Experience</h6>
                        {job?.level || "N/A"}{" "}
                      </td>
                      <td className="border-0">
                        <h6 className="text-secondary">Expected Salary</h6>
                        {job?.salary || "N/A"}{" "}
                      </td>
                      <td className="border-0">
                        <h6 className="text-secondary">Expiry Date</h6>
                        {job?.expiry || "N/A"}{" "}
                      </td>
                      <td className="border-0">
                        <div className="d-flex flex-column">
                          <button
                            className="btn btn-success mb-2"
                            //onClick={() => handleShortlist(job?.id)} // Call a function to handle shortlisting
                          >
                            Shortlisted
                          </button>
                          <button
                            className="btn btn-secondary"
                            //onClick={() => handleReject(job?.id)} // Call a function to handle rejection
                          >
                            Rejected
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">
                      <Card.Body className="pt-0">
                        <Card className="mt-2">
                          <h6 className="p-3">No Applicants!</h6>
                        </Card>
                      </Card.Body>
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot></tfoot>
            </table>
          </div>
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default All;
